var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "emd-card",
    { staticClass: "_footer_spaced_sm", attrs: { noBorder: "" } },
    [
      _c(
        "emd-card-header",
        {
          scopedSlots: _vm._u([
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    "router-link",
                    {
                      staticClass: "jsModalOpen",
                      attrs: { to: { name: "invites-create" } },
                    },
                    [
                      _c(
                        "jade-button",
                        { attrs: { variant: "primary-solid", size: "small" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("invite.list.button-invite")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("emd-text", { attrs: { tag: "h2" } }, [
            _vm._v(_vm._s(_vm.$t("invite.list.title"))),
          ]),
        ],
        1
      ),
      _vm.alert.show
        ? _c("invite-alert", {
            attrs: { alert: _vm.alert },
            on: {
              cancel: function ($event) {
                return _vm.$emit("resetAlert")
              },
            },
          })
        : _vm._e(),
      _c(
        "emd-card-content",
        { attrs: { customClass: "eu-no-padding" } },
        [
          _vm.showEmptyList
            ? _c("empty-list", { attrs: { entity: "invites" } })
            : [
                _c("InvitesTable", {
                  attrs: { items: _vm.items, actions: _vm.actions() },
                }),
                _c("pagination", {
                  attrs: {
                    type: "list",
                    action: _vm.action,
                    pagination: _vm.pagination,
                    totalShowing: _vm.totalItems,
                  },
                }),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }